import utils from '@/plugins/TravellerUtils'
import olf from '@/components/Map/OpenLayersFunctions.js'
import copy from 'fast-copy';
import stop from '@/store/timetable/stop'
import infopoint from '@/store/displays/infopoint'
import timetable from '@/store/timetable/timetable'
import realtime from '@/store/realtime/realtime'
import system from '@/store/system/system'
import sseDisplay from '@/store/displays/sseDisplay'
import moment from 'moment'

const helpers = {
    stopFilter(filter, stopItem) {
        let pass = false

        // filtteröidään vain jos oikeasti jotain mitä filtteröidä
        if (filter.text == null || filter.text.length == 0) {
            pass = true
        } else {
            let matchString = '.*' + filter.text + '.*'

            // Vapaa sanahaku
            let matchTarget = stopItem.tunnus + stopItem.nimi
            let regxi = new RegExp(matchString, 'i')
            pass = regxi.test(matchTarget)
        }
        if (!pass) {
            return false
        }

        // Pysäkin linjan tyyppi
        let lineType = null
        if (stopItem.stopFeatures) {
            lineType = stopItem.stopFeatures.LINE_TYPE
        }

        if (
            filter.type == 'NOFILTER' ||
            filter.type == null ||
            filter.type.length == 0
        ) {
            pass = true
        } else if (lineType == null) {
            pass = false
        } else {
            if (filter.type == lineType) {
                pass = true
            } else {
                pass = false
            }
        }

        return pass
    },
    routeFilter(filter, routeItem) {
        let pass = false
        let routeType = null
        routeType = routeItem.vehicleTyyppi
        // filtteröidään vain jos oikeasti jotain mitä filtteröidä
        if ((filter.text == null || filter.text.length == 0) && filter.type == 'NOFILTER')
            return true;

        let matchString = '.*' + filter.text + '.*'

        let matchTarget =
            routeItem.kuvaus +
            '#' +
            routeItem.linja +
            '#' +
            routeItem.nimi +
            '#' +
            routeItem.tunnus
        routeItem.destinations.forEach((d) => {
            try {
                matchTarget = matchTarget + '#' + d.nimi
            } catch (err) {
                /**/
            }
        })
        let regxi = new RegExp(matchString, 'i')
        pass = regxi.test(matchTarget)
        if (!pass) {
            return false
        }

        // reitin tyyppi
        if (
            filter.type == 'NOFILTER' ||
            filter.type == null ||
            filter.type.length == 0
        ) {
            pass = true
        } else if (routeType == null) {
            pass = false
        } else {
            if (filter.type == routeType) {
                pass = true
            } else {
                pass = false
            }
        }

        return pass
    },
    deviceFilter(filter, devItem) {
        // filtteröidään vain jos oikeasti jotain mitä filtteröidä
        if (filter.text == null || filter.text.length == 0) return true
        let matchString = '.*' + filter.text + '.*'

        let matchTarget = ''
        try {
            matchTarget = devItem.name
            if (devItem.uniqueId != undefined)
                matchTarget = matchTarget + '#' + devItem.uniqueId
        } catch (err) {
            /*console.log(devItem)*/
        }
        let regxi = new RegExp(matchString, 'i')
        return regxi.test(matchTarget)
    },
    /**
     * assignment: 0 = no filter, 1 = assigned(has block info) 2 = Block == null
     * line: NOFILTER : no selection, other values == lineLabel
     * status:  0 = no filter, 1 = on schedule 2 = late, 3 = ahead of schedule
     * text : text search
     * type: NOFILTER = no filter, Other values as text
     *
     */
    vehicleFilter(filter, vehItem) {
        let vehLine = null
        let vehicleTripShortName = null;
        let vehStatus = null
        let vehMatchString = null
        let vehType = null
        let vehAssignment = null
        let compType = null
        let vehRtStatus = null

        if (vehItem.type != undefined && vehItem.type == 'Feature') {
            // vehItem oli OpenLayers Feature tyyppiä
            vehLine = vehItem.properties.lineLabel
            vehicleTripShortName = vehItem.properties.tripShortName;
            vehStatus = vehItem.properties.deviation_class
            vehRtStatus = vehItem.properties.realtimeStatus
            vehMatchString = vehItem.properties.vehicleLabel
            try {
                vehType = vehItem.properties.vehicleFeatures.vehicle_type
            } catch (error) {
                vehType = 'bus'
            }
            
            vehAssignment = vehItem.properties.blockSequence
            try {
                // since computer type might be totally missing, let's prepare for that
                compType = vehItem.properties.vehicleFeatures.vehicle_computer_type
            } catch (err) {
                compType = null
            }
        } else {
            if (vehItem.spatialData != undefined) {
                vehLine = vehItem.spatialData.properties.lineLabel
                vehicleTripShortName = vehItem.spatialData.properties.tripShortName;
                vehAssignment = vehItem.spatialData.properties.blockSequence
                vehStatus = vehItem.spatialData.properties.deviation_class
                vehRtStatus = vehItem.spatialData.properties.realtimeStatus
                try {
                    // since computer type might be totally missing, let's prepare for that
                    compType =
                        vehItem.spatialData.properties.vehicleFeatures.vehicle_computer_type
                } catch (err) {
                    compType = null
                }
            }
            vehMatchString = vehItem.vehicleLabel
            try {
            vehType = vehItem.features.VEHICLE_TYPE
            } catch (error) {
                console.warn('Vehicle type not found')
            }
        }

        let pass = false
        // filtteröidään vain jos oikeasti jotain mitä filtteröidä
        if (filter.text == null || filter.text.length == 0) {
            pass = true
        } else {
            let matchString = '.*' + filter.text + '.*'

            // Vapaa sanahaku
            let matchTarget = vehMatchString
            let regxi = new RegExp(matchString, 'i')
            pass = regxi.test(matchTarget)
        }
        if (!pass) {
            return false
        }

        // linjan tunnus
        if (
            filter.line == 'NOFILTER' ||
            filter.line == null ||
            filter.line.length == 0
        ) {
            pass = true
        } else if (vehLine == null) {
            pass = false
        } else {
            if (filter.line == vehLine) {
                pass = true
            } else {
                pass = false
            }
        }
        if (!pass) {
            return false
        }

        if (filter.tripShortName == 'NOFILTER' ||
            filter.tripShortName == null ||
            filter.tripShortName.length == 0) {
            pass = true;
        } else if (vehicleTripShortName == null) {
            pass = false;
        } else {
            if (filter.tripShortName == vehicleTripShortName) {
                pass = true;
            } else {
                pass = false;
            }
        }
        if (!pass) {
            return false;
        }
        // Blokki asetus
        if (
            filter.assignment == 'NOFILTER' ||
            filter.assignment == null ||
            filter.assignment == 0
        ) {
            pass = true
        } else if (filter.assignment == 1 && vehAssignment == null) {
            pass = false
        } else if (filter.assignment == 2 && vehAssignment != null) {
            pass = false
        }
        if (!pass) {
            return false
        }
        // realtime status 
        if (
            filter.realtimeStatus == 'NOFILTER' ||
            filter.realtimeStatus == null ||
            filter.realtimeStatus == 0
        ) {
            pass = true
        } else if (filter.realtimeStatus == 1 && vehRtStatus == 'no_gps') {
            pass = true
        } else if (filter.realtimeStatus == 2 && vehRtStatus == 'no_driving_cycles') {
            pass = true
        } else if (filter.realtimeStatus == 3 && vehRtStatus == 'inactive') {
            pass = true
        } else if (filter.realtimeStatus == 4 && vehRtStatus == 'unknown') {
            pass = true
        } else {
            pass = false
        }

        if (!pass) {
            return false
        }

        // Ajoneuvon tyyppi
        if (
            filter.type == 'NOFILTER' ||
            filter.type == null ||
            filter.type.length == 0
        ) {
            pass = true
        } else if (vehType == null) {
            pass = false
        } else {
            if (filter.type == vehType) {
                pass = true
            } else {
                pass = false
            }
        }
        if (!pass) {
            return false
        }

        // Ajoneuvon aikataulupoikkeama
        if (filter.status == 0 || filter.status == null) {
            pass = true
        } else if (vehStatus == null) {
            pass = false
        } else {
            if (filter.status == 1 && vehStatus == 2) {
                // class 2 = on schedule
                pass = true
            } else if (filter.status == 2 && vehStatus >= 3) {
                // class 3 and 4 means ahead of schedule
                pass = true
            } else if (filter.status == 3 && vehStatus <= 1) {
                // class 0 and 1 means late
                pass = true
            } else if (filter.status == 4 && vehStatus == 4) {
                pass = true
            } else if (filter.status == 5 && vehStatus == 0) {
                pass = true
            } else {
                pass = false
            }
        }
        if (!pass) {
            return false
        }

        // Ajoneuvotietokone
        if (
            filter.computer_type == 'NOFILTER' ||
            filter.computer_type == null ||
            filter.computer_type.length == 0
        ) {
            pass = true
        } else if (compType == null) {
            pass = false
        } else {
            if (filter.computer_type == compType) {
                pass = true
            } else {
                pass = false
            }
        }

        return pass
    },
}

const mapstore = {
    namespaced: true,
    modules: {
        stop,
        infopoint,
        timetable,
        realtime,
        system,
        sseDisplay,
    },
    state: {
        mapConfig: null,
        mapConfigPromise: null,
        vehicleBaseData: {
            vehicleList: [],
            dataTimestamp: null,
        },
        vehicleRealtimeData: {
            vehicleList: [],
            dataTimestamp: null,
        },
        stopSpatialData: {
            data: null,
            dataTimestamp: null,
        },
        deviceSpatialData: {
            data: null,
            dataTimestamp: null,
        },
        routeData: {
            listData: null,
            dataTimestamp: null,
        },
        devicesForTable: null,
        vehiclesForTable: null,
        vehiclesForMap: null,
        routesForMap: null,
        vehiclesForMapDataBuffer: null,
        filter: {
            vehicle: {
                text: '',
                assignment: '',
                line: '',
                status: '',
                realtimeStatus: '',
                type: '',
                computer_type: '',
                tripShortName: ''
            },
            stop: {
                text: '',
            },
            route: {
                text: '',
            },
            device: {
                text: '',
            },
        },
        storedFilter: {
            vehicle: {
                text: '',
                assignment: '',
                line: '',
                status: '',
                realtimeStatus: '',
                type: '',
                computer_type: '',
                tripShortName: ''
            },
            stop: {
                text: '',
            },
            route: {
                text: '',
            },
            device: {
                text: '',
            },
        },
        defaultMapConfig: {
            viewconfig: {
                center: [3311263.11, 9002356.3], // Joensuu
                extent: null,
                projection: 'EPSG:3857',
                zoom: 15,
            },
            baselayers: [
                {
                    name: 'traveller_baselayer',
                    type: 'trapeze',
                    projection: 'EPSG:3857',
                    url: 'https://tiles.trapeze.fi/tiles/{z}/{x}/{y}.png',
                },
            ],
            vehicleLayer: {
                realtimeData: {
                    updateIntervalSeconds: 3,
                    projection: 'EPSG:3857',
                    /*url:"/traveller/restui/map/simulateVehicleSpatialData?proj=EPSG:3857"*/
                    url: '/traveller/restui/map/getVehicleSpatialData?proj=EPSG:3857',
                },
                vehicleBaseData: {
                    projection: 'EPSG:3857',
                    url: '/traveller/restui/realtime/getVehicles',
                },
            },
            stopLayer: {
                name: 'traveller_stops',
                projection: 'EPSG:3857',
                url: '/traveller/restui/map/getStopSpatialData?proj=EPSG:3857',
            },
            lineLayer: {},
            routeLayer: {},
            deviceLayer: {
                updateIntervalSeconds: 15,
                projection: 'EPSG:3857',
                url: '/traveller/restui/map/getDeviceSpatialData?proj=EPSG:3857',
            },
        },
        vehicleHistory: {
            historyData: null,
            activeVehicleHistoryDetails: null,
            historyRouteSpatialData: new Map()
        },
    },
    mutations: {
        setMapConfig(state, conf) {
            state.mapConfig = conf
        },
        setMapConfigPromise(state, prom) {
            state.mapConfigPromise = prom
        },
        setVehicleBaseData(state, data) {
            state.vehicleBaseData.vehicleList = data
            state.vehicleBaseData.dataTimestamp = new Date().getTime()
        },
        setVehicleRealtimeData(state, data) {
            state.vehicleRealtimeData.vehicleList = data
            state.vehicleRealtimeData.dataTimestamp = new Date().getTime()
        },
        setStopSpatialData(state, data) {
            state.stopSpatialData.data = data
            state.stopSpatialData.dataTimestamp = new Date().getTime()
        },
        setDeviceSpatialData(state, data) {
            state.deviceSpatialData.data = data
            state.deviceSpatialData.dataTimestamp = new Date().getTime()
        },
        setRouteData(state, data) {
            state.routeData.listData = data
            state.routeData.dataTimestamp = new Date().getTime()
        },
        storeFilter(state) {
            state.storedFilter = JSON.parse(JSON.stringify(state.filter))
        },
        restoreFilterAndClearStored(state) {
            state.filter = JSON.parse(JSON.stringify(state.storedFilter))
            state.storedFilter = {
                vehicle: {
                    text: '',
                    assignment: '',
                    line: '',
                    status: '',
                    realtimeStatus: '',
                    type: '',
                    computer_type: '',
                    tripShortName: ''
                },
                stop: {
                    text: '',
                },
                route: {
                    text: '',
                },
                device: {
                    text: '',
                },
            }
        },
        setVehicleFilter(state, filter) {
            state.filter.vehicle.text = filter.text
            state.filter.vehicle.assignment = filter.assignmentOption
            state.filter.vehicle.line = filter.lineOption
            state.filter.vehicle.status = filter.statusOption
            state.filter.vehicle.realtimeStatus = filter.realtimeStatusOption
            state.filter.vehicle.type = filter.typeOption
            state.filter.vehicle.computer_type = filter.vehicleComputerOption
            state.filter.vehicle.tripShortName = filter.tripShortNameOption;
        },
        setStopFilter(state, filter) {
            state.filter.stop.text = filter.text
            state.filter.stop.type = filter.typeOption
        },
        setRouteFilter(state, filter) {
            state.filter.route.text = filter.text;
            state.filter.route.type = filter.typeOption;
        },
        setDeviceFilter(state, filter) {
            state.filter.device.text = filter.text
        },
        setVehicleHistoryData(state, histData) {
            state.vehicleHistory.historyData = histData
        },
        setActiveVehicleHistoryDetails(state, activeDetails) {
            state.vehicleHistory.activeVehicleHistoryDetails = activeDetails
        },
        setDevicesForTable(state, newDeviceList) {
            state.devicesForTable = newDeviceList
        },
        setVehiclesForTable(state, newVehicleList) {
            state.vehiclesForTable = newVehicleList
        },
        setRoutesForMap(state, newVehicleList) {
            state.routesForMap = newVehicleList
        },
        setVehiclesForMap(state, newVehicleList) {
            state.vehiclesForMap = newVehicleList
        },
        setVehiclesForMapDataBuffer(state, newVehicleList) {
            state.vehiclesForMapDataBuffer = newVehicleList;
        },
        addHistoryRouteSpatialData(state, data) {
            state.vehicleHistory.historyRouteSpatialData.set(data.key, data.data);
        }
    },
    actions: {
        /*
         * getMapConfig nappaa storesta default asetukset ja niiden päälle
         * se lisää/korvaa travellerista tulleet asetukset.
         * Näin travellerissa ei tarvitse asettaa kuin vain defaultista
         * poikkeavat arvot
         */
        getMapConfig(context) {
            const merge = require('deepmerge')

            return new Promise((resolve, reject) => {
                // Jos mapConfig on suoraan tallessa storessa palautetaan se sieltä.
                if (context.state.mapConfig != null) {
                    resolve(context.state.mapConfig)
                    return
                }

                // Tilanne jossa mapconfigia ollaan pyydetty palvelimelta mutta sitä ei ole vielä saatu
                // Tällöin lisätään configia hakevan promisen ketjuun then jossa resolvataan myös nykyinen mapconfigin haku.
                // Näin palvelinta ei pommiteta useilla confikin pyynnöillä vaan asiat tapahtuu sitten kun config on tarjolla
                //
                if (context.state.mapConfigPromise != null) {
                    context.state.mapConfigPromise.then(() => {
                        resolve(context.state.mapConfig)
                    })
                    return
                }

                // Konffi joudutaan pyytämään palvelimelta. Tee pyyntö ja aseta pyynnöstä tuleva
                // promise talteen jotta siihen voidaan lisätä then handlejä jos pyynnön aikana tulee muita pyytäjiä
                // Data laitetaan myös storeen talteen
                // Kun pyyntöön on saatu vastaus palvelimelta voidaan promise poistaa ja vastaus annetaan vain suoraan storesta.
                let prom = this._vm.$traveller_http
                    .get('/traveller/restui/map/getMapconfig')
                    .then(function (response) {
                        if (utils.checkResponseIsObject(response)) {
                            const overwriteMerge = (destinationArray, sourceArray) =>
                                sourceArray
                            let defaults = context.state.defaultMapConfig
                            let conf = merge(defaults, response.data, {
                                arrayMerge: overwriteMerge,
                            })
                            context.commit('setMapConfig', conf)
                            context.commit('setMapConfigPromise', null)
                            resolve(conf)
                        } else {
                            context.commit('setMapConfigPromise', null)
                            reject('No configuration!')
                        }
                    })
                context.commit('setMapConfigPromise', prom)
            })
        },
        getVehicleRealTimeData(context) {
            return new Promise((resolve, reject) => {
                let devColors = context.dispatch('system/getDeviationColors')
                let mapConfig = context.dispatch('getMapConfig')
                Promise.all([devColors, mapConfig]).then(() => {
                    this._vm.$traveller_http
                        .get(context.state.mapConfig.vehicleLayer.realtimeData.url)
                        .then(function (response) {
                            if (utils.checkResponseObjectWithMemeber(response, 'features')) {
                                let rules = context.state.system.travellerParameters.VEHICLE_SCHEDULE_DEVIATION_COLORS
                                let vehicleList = response.data.features

                                vehicleList.forEach((v) => {
                                    v.properties.deviation_class = olf.getScheduleDeviationClass(v, rules)
                                })
                                context.commit('setVehicleRealtimeData', response.data)
                                resolve(response.data)
                            } else {
                                reject('Error getting vehicle realtime data')
                            }
                        })
                        .catch((err) => {
                            reject(err)
                        })
                })
            })
        },
        getAllVehicleData(context, expireTime) {
            let vehiclePromise = null
            if (context.state.vehicleBaseData.vehicleList.length <= 0) {
                vehiclePromise = new Promise((resolve) => {
                    context.dispatch('realtime/getVehicles').then((data) => {
                        context.commit('setVehicleBaseData', data)
                        resolve(data)
                    })
                })
            } else {
                vehiclePromise = new Promise((resolve) => {
                    resolve(context.state.vehicleBaseData.vehicleList)
                })
            }

            // spatialData tarkoittaa Realtime dataa.
            let spatialPromise = null
            let now = new Date().getTime()
            if (
                context.state.vehicleRealtimeData.dataTimestamp + expireTime * 1000 >=
                now
            ) {
                spatialPromise = new Promise((resolve) => {
                    resolve(context.state.vehicleRealtimeData.vehicleList)
                })
            } else {
                spatialPromise = context.dispatch('getVehicleRealTimeData')
            }

            return Promise.all([vehiclePromise, spatialPromise])
        },
        getVehiclesForMap(context, params) {
            return new Promise((resolve, reject) => {
                context
                    .dispatch('getAllVehicleData', params.expireTime)
                    .then((data) => {
                        context.commit('setVehiclesForMapDataBuffer', data);
                        context.dispatch('updateVehiclesForMap', params);
                        resolve(data);
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        updateVehiclesForMap(context, params) {

            if (context.state.vehiclesForMapDataBuffer == null || context.state.vehiclesForMapDataBuffer.length < 2) {
                return;
            }
            let geoJson = copy(context.state.vehiclesForMapDataBuffer[1]);

            let featList = geoJson.features;
            let vehicles = context.state.vehiclesForMapDataBuffer[0];
            let filter = context.state.filter.vehicle;
            let returnList = new Array();
            let vehicleList = JSON.parse(JSON.stringify(vehicles));
            vehicleList.forEach((v) => {
                let found = featList.find((f) => f.properties.vehicleLabel == v.vehicleLabel)
                if (found &&
                    params.minX < found.geometry.coordinates[0] &&
                    found.geometry.coordinates[0] < params.maxX &&
                    params.minY < found.geometry.coordinates[1] &&
                    found.geometry.coordinates[1] < params.maxY) {

                    found.properties.vehicleData = v;
                    returnList.push(found);
                }
            });

            returnList = returnList.filter((s) =>
                helpers.vehicleFilter(filter, s)
            );

            geoJson.features = returnList;
            context.commit('setVehiclesForMap', geoJson);


        },
        getVehiclesForTable(context, expireTime) {
            return new Promise((resolve, reject) => {
                context
                    .dispatch('getAllVehicleData', expireTime)
                    .then((data) => {
                        let geoJson = data[1]
                        let featList = JSON.parse(JSON.stringify(geoJson.features))
                        let vehicleList = JSON.parse(JSON.stringify(data[0]))
                        let filter = context.state.filter.vehicle
                        vehicleList.forEach((v) => {
                            let found = featList.find(
                                (f) => f.properties.vehicleLabel == v.vehicleLabel
                            )
                            if (found) {
                                v.spatialData = found
                            } else {
                                v.spatialData = null
                            }
                        })
                        vehicleList = vehicleList.filter((s) =>
                            helpers.vehicleFilter(filter, s)
                        )
                        context.commit('setVehiclesForTable', vehicleList)
                        resolve(vehicleList)
                    })
                    .catch((error) => {
                        reject(error)
                    })
            })
        },
        getRoutesForMap(context, expireTime) {
            return new Promise((resolve, reject) => {
                context
                    .dispatch('getAllVehicleData', expireTime)
                    .then((data) => {
                        let geoJson = data[1]
                        let featList = JSON.parse(JSON.stringify(geoJson.features))
                        let vehicleList = JSON.parse(JSON.stringify(data[0]))
                        let filter = context.state.filter.vehicle

                        vehicleList.forEach((v) => {
                            let found = featList.find(
                                (f) => f.properties.vehicleLabel == v.vehicleLabel
                            )
                            if (found) {
                                v.spatialData = found
                            } else {
                                v.spatialData = null
                            }
                        })

                        vehicleList = vehicleList.filter((s) =>
                            helpers.vehicleFilter(filter, s)
                        )
                        context.commit('setRoutesForTable', vehicleList)
                        resolve(vehicleList)
                    })
                    .catch((error) => {
                        reject(error)
                    })
            })
        },
        /* palauttaa pysäkkidatan joka on yhdistelmä paikkatietoa ja stop-storesta tullutta
         * pysäkkidataa */
        getAllStopData(context) {
            let stopPromise = null
            if (context.state.stop.stopList.length <= 0) {
                stopPromise = context.dispatch('stop/getStopList')
            } else {
                stopPromise = new Promise((resolve) => {
                    resolve(context.state.stop.stopList)
                })
            }

            let spatialPromise = null
            if (context.state.stopSpatialData.data == null) {
                spatialPromise = context.dispatch('getStopSpatialData')
            } else {
                spatialPromise = new Promise((resolve) => {
                    resolve(context.state.stopSpatialData.data)
                })
            }

            return Promise.all([stopPromise, spatialPromise])
        },
        getStopsForMap(context) {
            return new Promise((resolve, reject) => {
                context.dispatch('getAllStopData').then(
                    (data) => {
                        let geoJson = JSON.parse(JSON.stringify(data[1]))
                        let featList = geoJson.features
                        let stopit = data[0]
                        let filter = context.state.filter.stop
                        let returnList = new Array()

                        stopit = stopit.filter((s) => helpers.stopFilter(filter, s))
                        let stopList = JSON.parse(JSON.stringify(stopit))
                        stopList.forEach((s) => {
                            let found = featList.find((f) => f.properties.tunnus == s.tunnus)
                            if (found) {
                                found.properties.stopData = s
                                returnList.push(found)
                            }
                        })

                        geoJson.features = returnList
                        resolve(geoJson)
                    },
                    (error) => {
                        reject(error)
                    }
                )
            })
        },
        getStopsForTable(context) {
            return new Promise((resolve, reject) => {
                context.dispatch('getAllStopData').then(
                    (data) => {
                        let geoJson = data[1]
                        let featList = JSON.parse(JSON.stringify(geoJson.features))
                        let stopList = JSON.parse(JSON.stringify(data[0]))
                        let filter = context.state.filter.stop

                        stopList = stopList.filter((s) => helpers.stopFilter(filter, s))

                        stopList.forEach((s) => {
                            let found = featList.find((f) => f.properties.tunnus == s.tunnus)
                            if (found) s.spatialData = found
                            else s.spatialData = null
                        })

                        resolve(stopList)
                    },
                    (error) => {
                        reject(error)
                    }
                )
            })
        },
        getStopSpatialData(context) {
            return new Promise((resolve, reject) => {
                if (context.state.stopSpatialData.data != null) {
                    resolve(context.state.stopSpatialData.data)
                    return
                }

                context.dispatch('getMapConfig').then(() => {
                    this._vm.$traveller_http
                        .get(context.state.mapConfig.stopLayer.url)
                        .then(function (response) {
                            if (utils.checkResponseObjectWithMemeber(response, 'features')) {
                                context.commit('setStopSpatialData', response.data)
                                resolve(response.data)
                            } else {
                                reject('Error getting stop data')
                            }
                        })
                        .catch((error) => {
                            reject(error)
                        })
                })
            })
        },
        getAllDeviceData(context, expireTime) {
            //console.log("exp time: " + expireTime)
            let ipPromise = context.dispatch('infopoint/getInfopointList', expireTime)
            let spatialPromise = context.dispatch('getDeviceSpatialData', expireTime)
            let devPromise = context.dispatch('sseDisplay/getDisplayList', expireTime)

            return Promise.all([ipPromise, spatialPromise, devPromise])
        },
        getDevicesForMap(context, expireTime) {
            return new Promise((resolve, reject) => {
                context.dispatch('getAllDeviceData', expireTime).then(
                    (data) => {
                        let geoJson = JSON.parse(JSON.stringify(data[1]))
                        let featList = geoJson.features
                        let ipList = data[0]
                        let sseList = data[2]
                        let filter = context.state.filter.device
                        let returnList = new Array()

                        let devit = ipList.filter((s) => helpers.deviceFilter(filter, s))
                        sseList = sseList.filter((s) => helpers.deviceFilter(filter, s))

                        devit = devit.filter((d) => d.device != null)
                        let devList = JSON.parse(JSON.stringify(devit))
                        // Infopointit
                        devList.forEach((s) => {
                            let found = featList.find((f) => {
                                return f.properties.deviceId == s.device.deviceId
                            })
                            if (found) {
                                found.properties.infopointData = s
                                returnList.push(found)
                            }
                        })
                        // SSE devices
                        sseList.forEach((s) => {
                            let found = featList.find((f) => {
                                return f.properties.deviceId == s.deviceId
                            })
                            if (found) {
                                found.properties.deviceData = s
                                returnList.push(found)
                            }
                        })

                        geoJson.features = returnList
                        resolve(geoJson)
                    },
                    (error) => {
                        reject(error)
                    }
                )
            })
        },
        getDevicesForTable(context, expireTime) {
            return new Promise((resolve, reject) => {
                context
                    .dispatch('getAllDeviceData', expireTime)
                    .then((data) => {
                        let geoJson = data[1]
                        let sseList = data[2]
                        let featList = geoJson.features
                        let devList = JSON.parse(JSON.stringify(data[0]))
                        let filter = context.state.filter.device

                        devList = devList.filter((s) => helpers.deviceFilter(filter, s))
                        sseList = sseList.filter((s) => helpers.deviceFilter(filter, s))

                        devList.forEach((d) => {
                            let found = featList.find((f) => {
                                try {
                                    return f.properties.deviceId == d.device.deviceId
                                } catch (err) {
                                    /*err*/
                                    return
                                }
                            })
                            if (found) d.spatialData = JSON.parse(JSON.stringify(found))
                            else d.spatialData = null
                        })
                        sseList.forEach((d) => {
                            let found = featList.find((f) => {
                                try {
                                    return f.properties.deviceId == d.deviceId
                                } catch (err) {
                                    /*err*/
                                    return
                                }
                            })
                            if (found) d.spatialData = JSON.parse(JSON.stringify(found))
                            else d.spatialData = null
                        })
                        let toReturn = devList.concat(sseList)
                        context.commit('setDevicesForTable', toReturn)
                        resolve(toReturn)
                    })
                    .catch((error) => {
                        reject(error)
                    })
            })
        },
        getDeviceSpatialData(context, expireTime) {
            return new Promise((resolve, reject) => {
                let now = new Date().getTime()
                try {
                    if (context.state.deviceSpatialData.data != null) {
                        if (
                            context.state.deviceSpatialData.dataTimestamp +
                            expireTime * 1000 >=
                            now
                        ) {
                            resolve(context.state.deviceSpatialData.data)
                            return
                        }
                    }
                } catch (err) {
                    /*empty*/
                }

                context.dispatch('getMapConfig').then(() => {
                    this._vm.$traveller_http
                        .get(context.state.mapConfig.deviceLayer.url)
                        .then(function (response) {
                            if (utils.checkResponseObjectWithMemeber(response, 'features')) {
                                context.commit('setDeviceSpatialData', response.data)
                                resolve(response.data)
                            } else {
                                reject('Error getting device data')
                            }
                        })
                        .catch(() => {
                            reject('Error getting device data')
                        })
                    //, error => { reject(error); }
                })
            })
        },
        getRoutesForTable(context) {
            return new Promise((resolve, reject) => {
                let data = null
                let filter = context.state.filter.route

                if (context.state.routeData.listData != null) {
                    data = context.state.routeData.listData
                    let reitit = data.filter((s) => helpers.routeFilter(filter, s))
                    let routeList = JSON.parse(JSON.stringify(reitit))
                    resolve(routeList)
                    return
                }

                context
                    .dispatch('timetable/getRoutesWithDestinations')
                    .then((dispatchData) => {
                        context.commit('setRouteData', dispatchData)
                        let reitit = dispatchData.filter((s) =>
                            helpers.routeFilter(filter, s)
                        )
                        let routeList = JSON.parse(JSON.stringify(reitit))
                        resolve(routeList)
                    })
                    .catch((error) => {
                        reject(error)
                    })
            })
        },
        getRouteTypes(context) {
            return new Promise((res, rej) => {
                new Promise((resolve, reject) => {
                    let data = null

                    if (context.state.routeData.listData != null) {
                        data = context.state.routeData.listData
                        let routeList = JSON.parse(JSON.stringify(data))
                        resolve(routeList)
                        return
                    }

                    context
                        .dispatch('timetable/getRoutesWithDestinations')
                        .then((dispatchData) => {
                            context.commit('setRouteData', dispatchData)
                            let routeList = JSON.parse(JSON.stringify(dispatchData))
                            resolve(routeList)
                        })
                        .catch((error) => {
                            reject(error)
                        })
                })
                    .then((routes) => {
                        let typeSet = new Set()
                        routes.forEach((r) => {
                            try {
                                if (r.vehicleTyyppi !== undefined && r.vehicleTyyppi != null) {
                                    typeSet.add(r.vehicleTyyppi)
                                }
                            } catch (err) {
                                /*empty*/
                            }
                        })

                        res(Array.from(typeSet))
                    })
                    .catch(() => {
                        rej('Error getting types')
                    })
            })
        },
        getRouteSpatialData(context, routeId) {
            return new Promise((resolve, reject) => {
                if (!routeId) {
                    reject('No routeId provided');
                    return;
                }

                let today = moment().format('YYYY-MM-DD');
                let key = routeId + '_' + today;
                if(context.state.vehicleHistory.historyRouteSpatialData.has(key)) {
                    resolve(context.state.vehicleHistory.historyRouteSpatialData.get(key));
                    return;
                }

                context.dispatch('getMapConfig').then(() => {
                    let projection = context.state.mapConfig.viewconfig.projection
                    this._vm.$traveller_http
                        .get('/traveller/restui/map/getRouteSpatialData', {
                            params: { proj: projection, routeId: routeId },
                        })
                        .then(function (response) {
                            if (utils.checkResponseObjectWithMemeber(response, 'features')) {
                                context.commit('addHistoryRouteSpatialData', { key: key, data: response.data } );
                                resolve(response.data);
                            } else {
                                reject('No spatial data for route');
                            }
                        })
                        .catch((error) => {
                            reject(error);
                        })
                })
            })
        },
        getHistoricRouteSpatialData(context, parameters) {
            return new Promise((resolve, reject) => {
                if (!parameters.routeId || !parameters.date) {
                    reject('No routeId or date provided');
                    return;
                }

                let today = moment().format('YYYY-MM-DD');
                if (parameters.date === today) {
                    context.dispatch('getRouteSpatialData', parameters.routeId)
                        .then(resolve)
                        .catch(reject);
                    return;
                }

                let key = parameters.routeId + '_' + parameters.date;
                if(context.state.vehicleHistory.historyRouteSpatialData.has(key)) {
                    resolve(context.state.vehicleHistory.historyRouteSpatialData.get(key));
                    return;
                }

                const params = new URLSearchParams([
                    ['proj', 'EPSG:3857'],
                    ['routeId', parameters.routeId],
                    ['date', parameters.date],
                ])

                this._vm.$traveller_http
                    .get('/traveller/restui/map/getHistoricRouteSpatialData', { params })
                    .then((response) => {
                        if (utils.checkResponseObjectWithMemeber(response, 'features')) {
                            context.commit('addHistoryRouteSpatialData', { key: key, data: response.data } );
                            resolve(response.data);
                        } else {
                            reject('No spatial data for route');
                        }
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        getVehicleStatusOnRoute(_context, vehicleId) {
            return new Promise((resolve, reject) => {
                const params = new URLSearchParams([['vehicleLabel', vehicleId]])
                this._vm.$traveller_http
                    .get(
                        '/traveller/restui/realtime/getDeparturesAndDeviationsOnRouteForVehicle',
                        { params }
                    )
                    .then((response) => {
                        if (utils.checkResponseIsObject(response)) {
                            resolve(response.data)
                        } else {
                            reject('Could not get vehicles status on route')
                        }
                    })
                    .catch((error) => {
                        reject(error)
                    })
            })
        },
        getVehicleHistory(_context, attribs /*computerLabel, start, end */) {
            return new Promise((resolve, reject) => {
                const params = new URLSearchParams([
                    ['proj', 'EPSG:3857'],
                    ['computerlabel', attribs[0]],
                    ['start', attribs[1]],
                    ['end', attribs[2]],
                ])
                this._vm.$traveller_http
                    .get('/traveller/restui/map/getVehicleHistory', { params })
                    .then((response) => {
                        if (utils.checkResponseIsArray(response)) {
                            resolve(response.data)
                        } else {
                            reject('Could not get vehicle history')
                        }
                    })
                    .catch((error) => {
                        reject(error)
                    })
            })
        },
    },
    getters: {
        runningLines(state) {
            // update lines list
            //debugger;
            if (state.vehicleRealtimeData.vehicleList.features == undefined) {
                return []
            }
            let lista = state.vehicleRealtimeData.vehicleList.features
            let lineSet = new Set()
            lista.forEach((v) => {
                try {
                    if (
                        v.properties.lineLabel != null &&
                        v.properties.lineLabel.length > 0
                    ) {
                        lineSet.add(v.properties.lineLabel)
                    }
                } catch (err) {
                    /*empty*/
                }
            })
            return Array.from(lineSet)
        },
        vehicleComputers(state) {
            if (state.vehicleRealtimeData.vehicleList.features == undefined) {
                return []
            }
            let lista = state.vehicleRealtimeData.vehicleList.features
            let compSet = new Set()
            lista.forEach((v) => {
                try {
                    if (
                        v.properties.vehicleFeatures.vehicle_computer_type != null &&
                        v.properties.vehicleFeatures.vehicle_computer_type.length > 0
                    ) {
                        compSet.add(v.properties.vehicleFeatures.vehicle_computer_type)
                    }
                } catch (err) {
                    /*empty*/
                }
            })
            return Array.from(compSet)
        },
    },
}

export default mapstore
